module.exports = __webpack_public_path__ + "assets/img/icon03.33ece377.jpg";